import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

// Hero Banner
import bannerImage from "../components/Assets/bannerimage.jpg";

// Sample images for manipulators (replace with your actual images)
import seatManipulator from "../components/Assets/SEATHANDLING.webp";
import beamManipulator from "../components/Assets/BEAMMEMBER.webp";

import Card from './../components/Commanbackgroundcard/Card';

const ErgonomicLiftPage = () => {
  // Core Services Data
  const services = [
    {
      name: "Seat Handling Zero Gravity Manipulator",
      image: seatManipulator,
      description:
        "Advanced lift assist system designed for ergonomic seat handling. Reduces operator fatigue while ensuring precise and safe positioning in assembly lines.",
    },
    {
      name: "Beam Member Handling Manipulator",
      image: beamManipulator,
      description:
        "Robust manipulator for handling heavy beam components. Enhances safety, efficiency, and accuracy in material handling for automotive and industrial applications.",
    },
  ];

  const industries = [
    { name: "Automotive", icon: "🚗" },
    { name: "Industrial Equipment", icon: "🏭" },
    { name: "Heavy Engineering", icon: "⚙️" },
    { name: "Electronics", icon: "💡" },
    { name: "Pharmaceuticals", icon: "💊" },
  ];

  const whyChoose = [
    "Ergonomic solutions minimizing operator fatigue",
    "Safe and precise material handling",
    "Customizable for various production lines",
    "Increases productivity and throughput",
    "End-to-end support from installation to commissioning",
    "Compliance with International Safety Standards",
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />

      {/* Page Heading Card */}
      <Card text="ERGONOMIC LIFT ASSIST & POWERTRAIN CONVEYOR" />

      {/* Intro Section */}
      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Smart Material Handling for{" "}
            <span className="text-[#F49100]">Efficiency & Safety</span>
          </h2>
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed max-w-4xl mx-auto">
            Our ergonomic lift assist systems and powertrain conveyors are
            designed to optimize material handling operations. Perfect for
            heavy components, these solutions reduce operator fatigue, improve
            workplace safety, and enhance productivity in automotive and
            industrial assembly lines.
          </p>
        </div>
      </section>

      {/* Core Services Section */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Our Core <span className="text-[#F49100]">Solutions</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Innovative manipulators and conveyors engineered for safety, precision, and efficiency.
          </p>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {services.map((service, i) => (
              <article
                key={i}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden border border-gray-100"
              >
                <div className="relative group">
                  <img
                    src={service.image}
                    alt={service.name}
                    className="w-full h-100 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    {service.name}
                  </h3>
                  <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Applications */}
      <section className="py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Industry <span className="text-[#F49100]">Applications</span>
          </h2>
          <p className="text-gray-700 mb-12 max-w-3xl mx-auto">
            Our solutions are deployed across multiple industries, tailored to meet each sector's unique material handling challenges.
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-5 gap-8 max-w-5xl mx-auto">
            {industries.map((ind, i) => (
              <div
                key={i}
                className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
              >
                <div className="text-5xl mb-4">{ind.icon}</div>
                <p className="text-gray-700 font-semibold text-center">
                  {ind.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Why Choose <span className="text-[#F49100]">Us</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Partner with a team focused on ergonomic efficiency, safety, and seamless material handling integration.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {whyChoose.map((point, i) => (
              <div
                key={i}
                className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-300"
              >
                <div className="w-3 h-3 bg-[#F49100] rounded-full mr-4 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-6 lg:px-12 bg-[#F49100] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Ready to Enhance Your Material Handling?
          </h2>
          <p className="mb-8 text-lg leading-relaxed">
            Contact us today to implement ergonomic lift assist and conveyor solutions designed for your production needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-white text-[#F49100] font-bold rounded-lg hover:bg-gray-100 transition duration-300"
            >
              Get in Touch
            </a>
            {/* <a
              href="/quote"
              className="inline-block px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-[#F49100] transition duration-300"
            >
              Request Quote
            </a> */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ErgonomicLiftPage;
